import { ClientStatusEnum, PermissionEnum } from '@api/enum';
import { Avatar, Button, Chip, Table } from '@hyperflake/react-ui-library';
import useClientListData from 'modules/clients/hooks/useClientListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { SearchBar } from 'modules/shared/features/search';
import useAuthPermission from 'modules/shared/hooks/use-auth-permission';
import { Link, useNavigate } from 'react-router-dom';

import { Tooltip } from '@library/tooltip';

const ClientListTable = () => {
    const navigate = useNavigate();

    const clientListData = useClientListData();

    const { hasPermission } = useAuthPermission();

    return (
        <>
            <div className="mt-4">
                <SearchBar value={clientListData.searchQuery} onChange={clientListData.setSearchQuery} />
            </div>

            <Table
                className="mt-4"
                borderStyle="divider"
                hover
                isLoading={clientListData.isLoading}
                data={clientListData.filteredClients}
                columns={[
                    {
                        header: 'ID',
                    },
                    {
                        header: 'Name',
                    },
                    {
                        header: 'Primary Color',
                    },
                    {
                        header: 'Domain',
                    },
                    {
                        header: 'Status',
                    },
                    // {
                    //     header: 'Edit',
                    // },
                ]}
                renderRow={(row) => (
                    <Table.Row key={row._id} onClick={() => navigate(`/push-notification/clients/${row._id}`)}>
                        <Table.Cell>
                            {
                                <Link to={`/clients/${row._id}/client-details`}>
                                    <div className="text-primary">{row._id}</div>
                                </Link>
                            }
                        </Table.Cell>
                        <Table.Cell>
                            <div className="flex items-center gap-2 ">
                                <div className="flex  gap-2">
                                    <div>
                                        <Tooltip placement="top" content={`Projects:${row.projectCount}`}>
                                            <div
                                                className={`w-2 h-2 rounded-full ${
                                                    row?.hasProjects ? 'bg-success-500 ' : 'bg-gray-400'
                                                }`}
                                                // style={{ top: '0', left: '0', transform: 'translate(50%, -50%)' }}
                                            ></div>
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Tooltip placement="bottom" content={`Users:${row.userCount}`}>
                                            <div
                                                className={` w-2 h-2  rounded-full  ${
                                                    row?.hasUsers ? 'bg-warning-500 ' : 'bg-gray-400'
                                                }`}
                                                // style={{ top: '0', left: '55%', transform: 'translate(50%, -50%)' }}
                                            ></div>
                                        </Tooltip>
                                    </div>
                                </div>

                                <Avatar src={row?.logoUrl} alt={row?.name} bgColor={row?.preferences?.primaryColor} />

                                {row?.name}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className="flex items-center gap-3 ">
                                <div
                                    className="h-5 w-5 rounded-full"
                                    style={{ backgroundColor: row.preferences.primaryColor }}
                                />
                                {row.preferences.primaryColor.toUpperCase()}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            {<span className="w-10 truncate">{row.domain ? row.domain : '-'}</span>}
                        </Table.Cell>
                        <Table.Cell>
                            <Chip
                                label={row.status}
                                color={row.status === ClientStatusEnum.ENABLED ? 'success' : 'danger'}
                                variant="shaded"
                            />
                        </Table.Cell>
                    </Table.Row>
                )}
            />
        </>
    );
};

export default ClientListTable;
